const countUserByRole = ( data, role ) => {
  if( ! data || ! role ) return null
  const user = data.filter((item) => {
    let tableRole = item.role ? item.role : item.invitationRole
    if ( typeof tableRole === 'undefined' ) tableRole = 'member'
    return tableRole.toLowerCase() === role.toLowerCase()
  }).length
  return user
}

const customFilterFn = ( row, columnId, filterValue ) => {
  return filterValue.includes(row.original[columnId])
}

const getSelectedData = ( data ) => {
  let checkedRoleValue = []
  let checkedRoleCount = 0
  data.map( filterData => {
    if( filterData.name === 'Role' ){
      filterData.items.forEach( item => {
        if( item.checked ){
          checkedRoleValue.push(item.name)
          checkedRoleCount+=item.count
        }
      }) 
    }
  })
  return {
    checkedRoleValue,
    checkedRoleCount
  } 
}

export {
  countUserByRole,
  customFilterFn,
  getSelectedData
}
